// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Box from "../../resources/layout-and-structure/Box.res.js";
import * as Env from "../../core/Env.res.js";
import * as Auth from "../../bundles/Auth/Auth.res.js";
import * as Form from "../../bundles/Form/Form.res.js";
import * as I18n from "../../primitives/I18n.res.js";
import * as Json from "../../primitives/Json.res.js";
import * as Group from "../../resources/layout-and-structure/Group.res.js";
import * as Stack from "../../resources/layout-and-structure/Stack.res.js";
import * as Title from "../../resources/typography/Title.res.js";
import * as React from "react";
import * as Button from "../../resources/actions/Button.res.js";
import * as Future from "rescript-future/src/Future.res.js";
import * as Inline from "../../resources/layout-and-structure/Inline.res.js";
import * as Request from "../../core/Request.res.js";
import * as Tooltip from "../../resources/overlays/Tooltip.res.js";
import * as DropZone from "../../resources/selection-and-input/DropZone.res.js";
import * as NextPage from "../../resources/layout-and-structure/NextPage.res.js";
import * as NextBadge from "../../resources/feedback-indicators/NextBadge.res.js";
import * as TextStyle from "../../resources/typography/TextStyle.res.js";
import * as FilePicker from "../../primitives/FilePicker.res.js";
import * as Navigation from "../../primitives/Navigation.res.js";
import * as NextBanner from "../../resources/feedback-indicators/NextBanner.res.js";
import * as CountryCode from "../../primitives/CountryCode.res.js";
import * as DateHelpers from "../../helpers/DateHelpers.res.js";
import * as StackFields from "../../resources/layout-and-structure/StackFields.res.js";
import * as TooltipIcon from "../../resources/overlays/TooltipIcon.res.js";
import * as Stdlib_Array from "@rescript/runtime/lib/es6/Stdlib_Array.js";
import * as CanarySurface from "../../resources/layout-and-structure/CanarySurface.res.js";
import * as ScrollHelpers from "../../helpers/ScrollHelpers.res.js";
import * as Stdlib_Option from "@rescript/runtime/lib/es6/Stdlib_Option.js";
import * as Stdlib_Result from "@rescript/runtime/lib/es6/Stdlib_Result.js";
import * as InputTextField from "../../resources/selection-and-input/InputTextField.res.js";
import * as SessionTracker from "../../core/SessionTracker.res.js";
import * as SettingsRoutes from "./SettingsRoutes.res.js";
import * as CanarySeparator from "../../resources/layout-and-structure/CanarySeparator.res.js";
import * as CorporateEntity from "../../core/CorporateEntity.res.js";
import * as ReactDomElement from "../../primitives/ReactDomElement.res.js";
import * as SiretInputField from "../../modules/SiretInputField.res.js";
import * as Stylex from "@stylexjs/stylex";
import * as Primitive_object from "@rescript/runtime/lib/es6/Primitive_object.js";
import * as Primitive_option from "@rescript/runtime/lib/es6/Primitive_option.js";
import * as JsxRuntime from "react/jsx-runtime";
import * as CompanyLegalNumber from "../../modules/CompanyLegalNumber.res.js";
import * as ElectronicInvoicing from "../../modules/ElectronicInvoicing/ElectronicInvoicing.res.js";
import * as FieldsetLayoutPanel from "../../resources/layout-and-structure/FieldsetLayoutPanel.res.js";
import * as AddressComboBoxField from "../../modules/AddressComboBoxField.res.js";
import * as CompanyComboBoxField from "../../modules/CompanyComboBoxField.res.js";
import * as FiscalYearOpeningMonth from "../../modules/FiscalYearOpeningMonth.res.js";
function encodeBody(id, name, address, postalCode, city, cityOfRegistryOffice, country, phoneNumber, email, website, fiscalYearEndClosingMonth, taxationRegime, employeesNumber, corporateName, legalRepresentative, legalForm, amountOfShareCapital, tvaNumber, siretNumber, rcsNumber, apeNafCode, bankName, bankCode, bankAccountHolder, bankAccountNumber, bicCode, ibanNumber) {
  return Json.encodeDict(Object.fromEntries([["id", Json.encodeString(id)], ["name", Json.encodeString(name)], ["address", Json.encodeString(address)], ["postalCode", Json.encodeString(postalCode)], ["city", Json.encodeString(city)], ["cityOfRegistryOffice", Json.encodeString(cityOfRegistryOffice)], ["country", Json.encodeString(country)], ["phoneNumber", Json.encodeString(phoneNumber)], ["email", Json.encodeString(email)], ["website", Json.encodeString(website)], ["fiscalYearEndClosingMonth", Json.encodeString(fiscalYearEndClosingMonth)], ["taxationRegime", Stdlib_Option.mapOr(taxationRegime, null, value => Json.encodeString(ElectronicInvoicing.TaxationRegime.toRaw(value)))], ["employeesNumber", Stdlib_Option.mapOr(employeesNumber, null, value => Json.encodeString(ElectronicInvoicing.EmployeesNumber.toRaw(value)))], ["corporateName", Json.encodeString(corporateName)], ["legalRepresentative", Json.encodeString(legalRepresentative)], ["legalForm", Json.encodeString(legalForm)], ["amountOfShareCapital", Json.encodeString(amountOfShareCapital)], ["tvaNumber", Json.encodeString(tvaNumber)], ["siretNumber", Json.encodeString(siretNumber)], ["rcsNumber", Json.encodeString(rcsNumber)], ["apeNafCode", Json.encodeString(apeNafCode)], ["bankName", Json.encodeString(bankName)], ["bankCode", Json.encodeString(bankCode)], ["bankAccountHolder", Json.encodeString(bankAccountHolder)], ["bankAccountNumber", Json.encodeString(bankAccountNumber)], ["bicCode", Json.encodeString(bicCode)], ["ibanNumber", Json.encodeString(ibanNumber)]]));
}
function decodeInvalidRequestFailure(serverFailure) {
  switch (serverFailure.kind) {
    case "AuthUserFromHttpRequestFailureCase":
      return "AuthUserFromHttpRequestFailureCase";
    case "CheckUserPermissionsFailureCase":
      return "CheckUserPermissionsFailureCase";
    case "NotFoundShopFailure":
      return "NotFoundShopFailure";
    case "ShopArchivedFailure":
      return "ShopArchivedFailure";
    default:
      return "UnknownFailure";
  }
}
let endpoint = Env.gatewayUrl() + "/shop";
function make(id, name, address, postalCode, city, cityOfRegistryOffice, country, phoneNumber, email, website, fiscalYearEndClosingMonth, taxationRegime, employeesNumber, corporateName, legalRepresentative, legalForm, amountOfShareCapital, tvaNumber, siretNumber, rcsNumber, apeNafCode, bankName, bankCode, bankAccountHolder, bankAccountNumber, bicCode, ibanNumber) {
  return Future.mapError(Request.make(endpoint, "PATCH", {
    TAG: "JsonBody",
    _0: encodeBody(id, name, address, postalCode, city, cityOfRegistryOffice, country, phoneNumber, email, website, fiscalYearEndClosingMonth, taxationRegime, employeesNumber, corporateName, legalRepresentative, legalForm, amountOfShareCapital, tvaNumber, siretNumber, rcsNumber, apeNafCode, bankName, bankCode, bankAccountHolder, bankAccountNumber, bicCode, ibanNumber)
  }, undefined, undefined), undefined, error => {
    if (typeof error !== "object" || error.TAG !== "InvalidRequestFailures") {
      return;
    } else {
      return Stdlib_Option.map(error._0[0], decodeInvalidRequestFailure);
    }
  });
}
let UpdateShopRequest = {
  encodeBody: encodeBody,
  decodeInvalidRequestFailure: decodeInvalidRequestFailure,
  endpoint: endpoint,
  make: make
};
function decodeInvalidRequestFailure$1(serverFailure) {
  switch (serverFailure.kind) {
    case "AuthUserFromHttpRequestFailureCase":
      return "AuthUserFromHttpRequestFailureCase";
    case "CheckUserPermissionsFailureCase":
      return "CheckUserPermissionsFailureCase";
    case "NotFoundShopFailure":
      return "NotFoundShopFailure";
    case "ShopArchivedFailure":
      return "ShopArchivedFailure";
    default:
      return "UnknownFailure";
  }
}
function make$1(shopId, logoFile) {
  let endpoint = Env.gatewayUrl() + "/shop-logo/" + shopId;
  return Future.mapError(Request.make(endpoint, "POST", {
    TAG: "FileBody",
    _0: logoFile
  }, undefined, undefined), undefined, error => {
    if (typeof error !== "object" || error.TAG !== "InvalidRequestFailures") {
      return;
    } else {
      return Stdlib_Option.map(error._0[0], decodeInvalidRequestFailure$1);
    }
  });
}
let UploadShopLogoRequest = {
  decodeInvalidRequestFailure: decodeInvalidRequestFailure$1,
  make: make$1
};
function get(values, field) {
  switch (field) {
    case "Name":
      return values.name;
    case "Email":
      return values.email;
    case "Address":
      return values.address;
    case "PostalCode":
      return values.postalCode;
    case "City":
      return values.city;
    case "CityOfRegistryOffice":
      return values.cityOfRegistryOffice;
    case "Country":
      return values.country;
    case "PhoneNumber":
      return values.phoneNumber;
    case "Website":
      return values.website;
    case "FiscalYearEndClosingMonth":
      return values.fiscalYearEndClosingMonth;
    case "TaxationRegime":
      return values.taxationRegime;
    case "CorporateName":
      return values.corporateName;
    case "LegalRepresentative":
      return values.legalRepresentative;
    case "LegalForm":
      return values.legalForm;
    case "AmountOfShareCapital":
      return values.amountOfShareCapital;
    case "EmployeesNumber":
      return values.employeesNumber;
    case "TvaNumber":
      return values.tvaNumber;
    case "SiretNumber":
      return values.siretNumber;
    case "RcsNumber":
      return values.rcsNumber;
    case "ApeNafCode":
      return values.apeNafCode;
    case "BankName":
      return values.bankName;
    case "BankCode":
      return values.bankCode;
    case "BankAccountHolder":
      return values.bankAccountHolder;
    case "BankAccountNumber":
      return values.bankAccountNumber;
    case "BicCode":
      return values.bicCode;
    case "IbanNumber":
      return values.ibanNumber;
  }
}
function set(values, field, value) {
  switch (field) {
    case "Name":
      let newrecord = {
        ...values
      };
      newrecord.name = value;
      return newrecord;
    case "Email":
      let newrecord$1 = {
        ...values
      };
      newrecord$1.email = value;
      return newrecord$1;
    case "Address":
      let newrecord$2 = {
        ...values
      };
      newrecord$2.address = value;
      return newrecord$2;
    case "PostalCode":
      let newrecord$3 = {
        ...values
      };
      newrecord$3.postalCode = value;
      return newrecord$3;
    case "City":
      let newrecord$4 = {
        ...values
      };
      newrecord$4.city = value;
      return newrecord$4;
    case "CityOfRegistryOffice":
      let newrecord$5 = {
        ...values
      };
      newrecord$5.cityOfRegistryOffice = value;
      return newrecord$5;
    case "Country":
      let newrecord$6 = {
        ...values
      };
      newrecord$6.country = value;
      return newrecord$6;
    case "PhoneNumber":
      let newrecord$7 = {
        ...values
      };
      newrecord$7.phoneNumber = value;
      return newrecord$7;
    case "Website":
      let newrecord$8 = {
        ...values
      };
      newrecord$8.website = value;
      return newrecord$8;
    case "FiscalYearEndClosingMonth":
      let newrecord$9 = {
        ...values
      };
      newrecord$9.fiscalYearEndClosingMonth = value;
      return newrecord$9;
    case "TaxationRegime":
      let newrecord$10 = {
        ...values
      };
      newrecord$10.taxationRegime = value;
      return newrecord$10;
    case "CorporateName":
      let newrecord$11 = {
        ...values
      };
      newrecord$11.corporateName = value;
      return newrecord$11;
    case "LegalRepresentative":
      let newrecord$12 = {
        ...values
      };
      newrecord$12.legalRepresentative = value;
      return newrecord$12;
    case "LegalForm":
      let newrecord$13 = {
        ...values
      };
      newrecord$13.legalForm = value;
      return newrecord$13;
    case "AmountOfShareCapital":
      let newrecord$14 = {
        ...values
      };
      newrecord$14.amountOfShareCapital = value;
      return newrecord$14;
    case "EmployeesNumber":
      let newrecord$15 = {
        ...values
      };
      newrecord$15.employeesNumber = value;
      return newrecord$15;
    case "TvaNumber":
      let newrecord$16 = {
        ...values
      };
      newrecord$16.tvaNumber = value;
      return newrecord$16;
    case "SiretNumber":
      let newrecord$17 = {
        ...values
      };
      newrecord$17.siretNumber = value;
      return newrecord$17;
    case "RcsNumber":
      let newrecord$18 = {
        ...values
      };
      newrecord$18.rcsNumber = value;
      return newrecord$18;
    case "ApeNafCode":
      let newrecord$19 = {
        ...values
      };
      newrecord$19.apeNafCode = value;
      return newrecord$19;
    case "BankName":
      let newrecord$20 = {
        ...values
      };
      newrecord$20.bankName = value;
      return newrecord$20;
    case "BankCode":
      let newrecord$21 = {
        ...values
      };
      newrecord$21.bankCode = value;
      return newrecord$21;
    case "BankAccountHolder":
      let newrecord$22 = {
        ...values
      };
      newrecord$22.bankAccountHolder = value;
      return newrecord$22;
    case "BankAccountNumber":
      let newrecord$23 = {
        ...values
      };
      newrecord$23.bankAccountNumber = value;
      return newrecord$23;
    case "BicCode":
      let newrecord$24 = {
        ...values
      };
      newrecord$24.bicCode = value;
      return newrecord$24;
    case "IbanNumber":
      let newrecord$25 = {
        ...values
      };
      newrecord$25.ibanNumber = value;
      return newrecord$25;
  }
}
let Lenses = {
  get: get,
  set: set
};
let ShopEditFormLenses = {
  Lenses: Lenses,
  get: get,
  set: set
};
let ShopEditForm = Form.Make({
  get: get,
  set: set
});
function countryFromShop(shop) {
  let match = CountryCode.parseIso3166Alpha2(shop.country);
  if (typeof match === "object") {
    return;
  }
  switch (match) {
    case "FR":
      return "FR";
    case "BE":
      return "BE";
    case "LU":
      return "LU";
  }
}
function isFrenchCountry(country) {
  if (country === undefined) {
    return true;
  }
  switch (country) {
    case "BE":
    case "LU":
      return false;
    default:
      return true;
  }
}
function SettingsShopsPage$ShopEditFormBankingInformationFieldset(props) {
  return JsxRuntime.jsxs(FieldsetLayoutPanel.make, {
    title: I18n.t("Banking information"),
    description: I18n.t("Enter your banking information. It will be shared with your customers for invoicing."),
    space: "xlarge",
    padding: "xxlarge",
    children: [JsxRuntime.jsxs(Group.make, {
      children: [JsxRuntime.jsx(ShopEditForm.InputText.make, {
        field: "BankName",
        label: I18n.t("Bank name"),
        placeholder: "CIC"
      }), JsxRuntime.jsx(ShopEditForm.InputText.make, {
        field: "BankCode",
        label: I18n.t("Bank code"),
        placeholder: "10057"
      })],
      spaceX: "xlarge",
      spaceY: "xlarge"
    }), JsxRuntime.jsxs(Group.make, {
      children: [JsxRuntime.jsx(ShopEditForm.InputText.make, {
        field: "BankAccountHolder",
        label: I18n.t("Bank account holder"),
        placeholder: "Jean Martin"
      }), JsxRuntime.jsx(ShopEditForm.InputText.make, {
        field: "BankAccountNumber",
        label: I18n.t("Bank account number"),
        placeholder: "01888457589"
      })],
      spaceX: "xlarge",
      spaceY: "xlarge"
    }), JsxRuntime.jsxs(Group.make, {
      children: [JsxRuntime.jsx(ShopEditForm.InputText.make, {
        field: "IbanNumber",
        label: I18n.t("IBAN number"),
        placeholder: "FR14 2004 1010 0505 0001 3M02 606"
      }), JsxRuntime.jsx(ShopEditForm.InputText.make, {
        field: "BicCode",
        label: I18n.t("BIC code"),
        placeholder: "CMCIFTPP"
      })],
      spaceX: "xlarge",
      spaceY: "xlarge"
    })]
  });
}
let make$2 = React.memo(SettingsShopsPage$ShopEditFormBankingInformationFieldset);
let ShopEditFormBankingInformationFieldset = {
  make: make$2
};
function SettingsShopsPage$ShopEditFormLegalInformationFieldset$SiretField(props) {
  let match = ShopEditForm.useField("SiretNumber", undefined, undefined, undefined, undefined);
  let onFocus = match.onFocus;
  return JsxRuntime.jsx(SiretInputField.make, {
    value: match.value,
    errored: Stdlib_Option.isSome(match.error),
    focused: match.focused,
    required: match.required,
    onChange: match.onChange,
    onCompanyFound: props.onCompanyFound,
    onFocus: () => onFocus(),
    onBlur: match.onBlur
  });
}
let SiretField = {
  make: SettingsShopsPage$ShopEditFormLegalInformationFieldset$SiretField
};
function SettingsShopsPage$ShopEditFormLegalInformationFieldset$CompanySearchField(props) {
  let dispatch = ShopEditForm.useFormDispatch();
  let match = React.useState(() => "");
  let setQuery = match[1];
  let onCompanySelected = company => {
    let legalRepresentative = [company.directorFirstName, company.directorLastName].filter(name => name !== "").join(" ");
    dispatch({
      TAG: "FieldValueChanged",
      _0: "CorporateName",
      _1: param => company.corporateName
    });
    [["SiretNumber", company.siret], ["TvaNumber", company.vatNumber], ["LegalRepresentative", legalRepresentative], ["Address", company.street], ["PostalCode", company.postalCode], ["City", company.city]].forEach(param => {
      let value = param[1];
      if (value !== "") {
        return dispatch({
          TAG: "FieldValueChanged",
          _0: param[0],
          _1: param => value
        });
      }
    });
  };
  return JsxRuntime.jsx(CompanyComboBoxField.make, {
    label: I18n.t("Search your company"),
    companyName: match[0],
    onInputChange: value => setQuery(param => value),
    onRequestAutoComplete: onCompanySelected
  });
}
let CompanySearchField = {
  make: SettingsShopsPage$ShopEditFormLegalInformationFieldset$CompanySearchField
};
function SettingsShopsPage$ShopEditFormLegalInformationFieldset(props) {
  let onCompanyFound = props.onCompanyFound;
  let legalForm = props.legalForm;
  let match = ShopEditForm.useFormState();
  let values = match.values;
  let isFrench = isFrenchCountry(values.country);
  let privacyRight = typeof legalForm === "object" ? legalForm.privacyRight : false;
  let title = I18n.t("Company information");
  let description = I18n.t("These details will be used for billing our services. They will also appear on your sales documents issued by the Wino software.");
  let match$1 = values.country;
  let tmp;
  if (match$1 !== undefined) {
    switch (match$1) {
      case "BE":
        tmp = JsxRuntime.jsx(ShopEditForm.InputText.make, {
          field: "SiretNumber",
          label: I18n.t("BCE number"),
          placeholder: I18n.t("Enter 10 digits"),
          hideRequired: true
        });
        break;
      case "LU":
        tmp = null;
        break;
      default:
        tmp = JsxRuntime.jsx(SettingsShopsPage$ShopEditFormLegalInformationFieldset$SiretField, {
          onCompanyFound: onCompanyFound
        });
    }
  } else {
    tmp = JsxRuntime.jsx(SettingsShopsPage$ShopEditFormLegalInformationFieldset$SiretField, {
      onCompanyFound: onCompanyFound
    });
  }
  let match$2 = values.country;
  let tmp$1;
  let exit = 0;
  if (match$2 !== undefined) {
    switch (match$2) {
      case "BE":
        tmp$1 = null;
        break;
      case "LU":
        tmp$1 = JsxRuntime.jsx(ShopEditForm.InputText.make, {
          field: "RcsNumber",
          label: I18n.t("RCSL number"),
          placeholder: I18n.t("B201345")
        });
        break;
      default:
        exit = 1;
    }
  } else {
    exit = 1;
  }
  if (exit === 1) {
    tmp$1 = JsxRuntime.jsx(ShopEditForm.InputText.make, {
      field: "RcsNumber",
      label: I18n.t("RCS number"),
      placeholder: I18n.t("RCS Paris B 812345678")
    });
  }
  let month = values.fiscalYearEndClosingMonth;
  let tmp$2;
  if (month !== undefined) {
    let match$3 = FiscalYearOpeningMonth.currentFiscalYearPeriod(undefined, month);
    tmp$2 = JsxRuntime.jsxs(NextBanner.make, {
      children: [JsxRuntime.jsx(NextBanner.Text.make, {
        text: I18n.t("Current fiscal year:") + " "
      }), JsxRuntime.jsx(NextBanner.Text.make, {
        text: I18n.template(I18n.t("from {{startDate}} to {{endDate}}"), {
          startDate: DateHelpers.formateToMediumDate(match$3[0]),
          endDate: DateHelpers.formateToMediumDate(match$3[1])
        }, undefined),
        bold: true
      })],
      variation: "info",
      compact: true
    });
  } else {
    tmp$2 = null;
  }
  return JsxRuntime.jsxs(FieldsetLayoutPanel.make, {
    title: title,
    description: description,
    children: [isFrench ? JsxRuntime.jsx(FieldsetLayoutPanel.Section.make, {
      accent: true,
      space: "xlarge",
      padding: "xxlarge",
      children: JsxRuntime.jsx(SettingsShopsPage$ShopEditFormLegalInformationFieldset$CompanySearchField, {})
    }) : null, JsxRuntime.jsxs(FieldsetLayoutPanel.Section.make, {
      title: I18n.t("Legal information"),
      space: "xlarge",
      padding: "xxlarge",
      children: [JsxRuntime.jsxs(Group.make, {
        children: [JsxRuntime.jsx(ShopEditForm.InputText.make, {
          field: "CorporateName",
          label: I18n.t("Corporate name"),
          placeholder: isFrench ? I18n.t("Search your company to fill in") : I18n.t("Company name as displayed on your official business registration document."),
          disabled: isFrench && !privacyRight
        }), JsxRuntime.jsx(ShopEditForm.InputSuggestionComboBox.make, {
          field: "LegalForm",
          label: I18n.t("Legal form"),
          placeholder: I18n.t("Legal form"),
          items: CorporateEntity.CompanyLegalForm.values.map(value => ({
            value: I18n.t(CorporateEntity.CompanyLegalForm.toString(value))
          }))
        })],
        spaceX: "xlarge",
        spaceY: "xlarge"
      }), JsxRuntime.jsx(SiretInputField.LegalFormBanner.make, {
        legalForm: legalForm
      }), JsxRuntime.jsxs(Group.make, {
        children: [JsxRuntime.jsx(ShopEditForm.InputText.make, {
          field: "LegalRepresentative",
          label: I18n.t("Legal representative"),
          placeholder: I18n.t("Anna Rossi")
        }), JsxRuntime.jsx(ShopEditForm.InputSelect.make, {
          field: "EmployeesNumber",
          label: I18n.t("Employees number"),
          placeholder: I18n.t("Select a number of employees"),
          sections: ElectronicInvoicing.EmployeesNumber.selectSections
        })],
        spaceX: "xlarge",
        spaceY: "xlarge"
      }), JsxRuntime.jsxs(Group.make, {
        children: [JsxRuntime.jsx(ShopEditForm.InputOptionalNumber.make, {
          field: "AmountOfShareCapital",
          label: I18n.t("Amount of share capital"),
          hideStepper: true,
          placeholder: "10 000,00",
          appender: {
            TAG: "Currency",
            _0: "EUR"
          },
          minValue: 0
        }), JsxRuntime.jsx(ShopEditForm.InputText.make, {
          field: "ApeNafCode",
          label: I18n.t("APE/NAF code"),
          placeholder: I18n.t("Enter a code of 4 digits and one letter")
        })],
        spaceX: "xlarge",
        spaceY: "xlarge"
      })]
    }), JsxRuntime.jsxs(FieldsetLayoutPanel.Section.make, {
      title: I18n.t("Legal and tax identification"),
      space: "xlarge",
      padding: "xxlarge",
      children: [JsxRuntime.jsxs(Group.make, {
        children: [tmp, JsxRuntime.jsx(ShopEditForm.InputText.make, {
          field: "TvaNumber",
          label: I18n.t("VAT number"),
          placeholder: I18n.t("FR 11 123123123"),
          hideRequired: true
        })],
        spaceX: "xlarge",
        spaceY: "xlarge"
      }), JsxRuntime.jsxs(Group.make, {
        children: [JsxRuntime.jsx(ShopEditForm.InputText.make, {
          field: "CityOfRegistryOffice",
          label: I18n.t("City of registry office"),
          placeholder: I18n.t("Paris")
        }), tmp$1],
        spaceX: "xlarge",
        spaceY: "xlarge"
      }), JsxRuntime.jsxs(Inline.make, {
        children: [JsxRuntime.jsx(InputTextField.make, {
          label: I18n.t("settings_electronic_invoicing_page.address_fieldset.content.input_label"),
          disabled: true,
          placeholder: I18n.t("Undefined"),
          value: ElectronicInvoicing.InvoicingEndpoint.formatOption(props.invoicingEndpoint)
        }), JsxRuntime.jsx(Button.make, {
          ariaLabel: I18n.t("settings_electronic_invoicing_page.title"),
          variant: {
            NAME: "ghost",
            VAL: {
              bordered: true
            }
          },
          icon: "legacy_settings",
          tooltipText: I18n.t("settings_electronic_invoicing_page.title"),
          href: SettingsRoutes.electronicInvoicingRoute,
          target: "_blank"
        })],
        space: "small",
        alignY: "bottom",
        grow: true
      })]
    }), JsxRuntime.jsx(FieldsetLayoutPanel.Section.make, {
      title: I18n.t("Other tax information"),
      space: "xlarge",
      padding: "xxlarge",
      children: JsxRuntime.jsxs(Group.make, {
        children: [JsxRuntime.jsx(ShopEditForm.InputSelect.make, {
          field: "TaxationRegime",
          label: I18n.t("settings_electronic_invoicing_page.account_creation_modal.form.taxation_regime.label"),
          placeholder: I18n.t("settings_electronic_invoicing_page.account_creation_modal.form.taxation_regime.placeholder"),
          sections: ElectronicInvoicing.TaxationRegime.selectSections
        }), JsxRuntime.jsxs(Stack.make, {
          children: [JsxRuntime.jsx(ShopEditForm.InputSelect.make, {
            field: "FiscalYearEndClosingMonth",
            label: I18n.t("Fiscal year end closing month"),
            tooltip: JsxRuntime.jsx(Tooltip.Span.make, {
              text: I18n.t("This setting will automatically be taken into account when creating your next annual Z, to ensure correct calculations over the reference period.")
            }),
            placeholder: I18n.t("Select a month"),
            sections: [{
              items: FiscalYearOpeningMonth.values.map(month => ({
                TAG: "Option",
                key: month,
                label: I18n.t(month),
                value: month
              }))
            }]
          }), tmp$2],
          space: "small"
        })],
        spaceX: "xlarge",
        spaceY: "xlarge"
      })
    })]
  });
}
let make$3 = React.memo(SettingsShopsPage$ShopEditFormLegalInformationFieldset);
let ShopEditFormLegalInformationFieldset = {
  SiretField: SiretField,
  CompanySearchField: CompanySearchField,
  make: make$3
};
let countryCodes = ["FR", "BE", "LU"];
function SettingsShopsPage$ShopEditFormAddressFieldset(props) {
  let dispatch = ShopEditForm.useFormDispatch();
  let match = ShopEditForm.useFormState();
  let validation = match.validation;
  let errorMessageAddress;
  if (validation.TAG === "Ok") {
    errorMessageAddress = undefined;
  } else {
    let tmp = match.submission;
    errorMessageAddress = typeof tmp !== "object" || tmp.TAG !== "Failed" ? undefined : Stdlib_Array.filterMap(validation._0, param => {
      if (param[0]._0 === "Address") {
        return param[1];
      }
    })[0];
  }
  let onChangeAddress = value => dispatch({
    TAG: "FieldValueChanged",
    _0: "Address",
    _1: param => value
  });
  let onRequestAutoComplete = address => {
    dispatch({
      TAG: "FieldValueChanged",
      _0: "Address",
      _1: param => address.name
    });
    dispatch({
      TAG: "FieldValueChanged",
      _0: "PostalCode",
      _1: param => address.postcode
    });
    dispatch({
      TAG: "FieldValueChanged",
      _0: "City",
      _1: param => address.city
    });
  };
  return JsxRuntime.jsxs(FieldsetLayoutPanel.make, {
    title: I18n.t("Postal address"),
    description: I18n.t("Enter your address. It will appear on your documents issued on app.wino.fr"),
    space: "xlarge",
    padding: "xxlarge",
    children: [JsxRuntime.jsx(AddressComboBoxField.make, {
      errorMessage: errorMessageAddress,
      required: true,
      addressName: match.values.address,
      onInputChange: onChangeAddress,
      onRequestAutoComplete: onRequestAutoComplete
    }), JsxRuntime.jsxs(Group.make, {
      children: [JsxRuntime.jsx(ShopEditForm.InputText.make, {
        field: "PostalCode",
        label: I18n.t("Postal code"),
        placeholder: I18n.t("Postal code")
      }), JsxRuntime.jsx(ShopEditForm.InputText.make, {
        field: "City",
        label: I18n.t("City"),
        placeholder: I18n.t("City")
      })],
      spaceX: "xlarge",
      spaceY: "xlarge"
    }), JsxRuntime.jsx(ShopEditForm.InputSelect.make, {
      field: "Country",
      label: I18n.t("Country"),
      disabled: props.countryDisabled,
      placeholder: I18n.t("Select a country"),
      sections: [{
        items: countryCodes.map(value => ({
          TAG: "Option",
          key: CountryCode.toIso2String(value),
          label: I18n.t(CountryCode.toMediumCountryString(value)),
          value: value
        }))
      }]
    })]
  });
}
let make$4 = React.memo(SettingsShopsPage$ShopEditFormAddressFieldset);
let ShopEditFormAddressFieldset = {
  countryCodes: countryCodes,
  make: make$4
};
let styles = {
  imagePreview: {
    "objectFit-kVIFPx": "objectFit-x19kjcj4",
    "height-kZKoxP": "height-xt7dq6l",
    "maxHeight-kskxy": "maxHeight-x1aoj0v",
    "maxWidth-ks0D6T": "maxWidth-x193iq5w",
    "width-kzqmXN": "width-x14atkfc",
    $$css: "wino-gc:src/app/Settings/SettingsShopsPage.res.js:963"
  },
  placeholderImage: {
    "maxHeight-kskxy": "maxHeight-x1aoj0v",
    "maxWidth-ks0D6T": "maxWidth-x16q51m2",
    $$css: "wino-gc:src/app/Settings/SettingsShopsPage.res.js:970"
  }
};
function SettingsShopsPage$ShopEditFormGeneralInformationFieldset(props) {
  let onLogoChange = props.onLogoChange;
  let shop = props.shop;
  let captureEvent = SessionTracker.useCaptureEvent();
  let match = React.useState(() => shop.logoUri);
  let setPreviewUrl = match[1];
  let previewUrl = match[0];
  let match$1 = React.useState(() => {});
  let setImportFailureMessage = match$1[1];
  let importFailureMessage = match$1[0];
  React.useEffect(() => {
    setPreviewUrl(param => shop.logoUri);
  }, [shop.id]);
  React.useEffect(() => () => {
    if (previewUrl !== undefined && previewUrl.startsWith("blob:")) {
      URL.revokeObjectURL(previewUrl);
      return;
    }
  }, [previewUrl]);
  let onFileSelect = file => {
    captureEvent("logo_import_select");
    if (file.size > 204800) {
      return setImportFailureMessage(param => I18n.t("The imported file is too heavy."));
    }
    if (previewUrl !== undefined && previewUrl.startsWith("blob:")) {
      URL.revokeObjectURL(previewUrl);
    }
    let url = URL.createObjectURL(file);
    setPreviewUrl(param => url);
    onLogoChange(Primitive_option.some(file));
    setImportFailureMessage(param => {});
  };
  let onFileError = errorMessage => setImportFailureMessage(param => errorMessage);
  let requirementsText = I18n.t("Max. weight: 200 KB · Formats: JPEG and PNG");
  let tmp;
  if (previewUrl !== undefined) {
    let newrecord = {
      ...{
        className: "objectFit-x19kjcj4 height-xt7dq6l maxHeight-x1aoj0v maxWidth-x193iq5w width-x14atkfc",
        "data-style-src": "wino-gc:src/app/Settings/SettingsShopsPage.res.js:963"
      }
    };
    tmp = JsxRuntime.jsx("img", (newrecord.src = previewUrl, newrecord.alt = I18n.t("Shop logo preview"), newrecord));
  } else {
    let newrecord$1 = {
      ...{
        className: "maxHeight-x1aoj0v maxWidth-x16q51m2",
        "data-style-src": "wino-gc:src/app/Settings/SettingsShopsPage.res.js:970"
      }
    };
    tmp = JsxRuntime.jsx("img", (newrecord$1.src = "/logo-placeholder.png", newrecord$1.alt = I18n.t("Logo placeholder"), newrecord$1));
  }
  return JsxRuntime.jsx(FieldsetLayoutPanel.make, {
    title: I18n.t("General store information"),
    description: I18n.t("Enter your shop name and contact information.\n\nImport your logo / image via the button. The visual will be used automatically on your professional emails and invoices.\nYou can modify it at any time."),
    space: "xlarge",
    padding: "xxlarge",
    children: JsxRuntime.jsxs(Group.make, {
      children: [JsxRuntime.jsxs(StackFields.make, {
        children: [JsxRuntime.jsx(ShopEditForm.InputText.make, {
          field: "Name",
          label: I18n.t("Shop name"),
          placeholder: I18n.t("Shop name")
        }), JsxRuntime.jsx(ShopEditForm.InputText.make, {
          field: "Email",
          label: I18n.t("Shop email address"),
          placeholder: "contact@boutique.com"
        }), JsxRuntime.jsx(ShopEditForm.InputText.make, {
          field: "PhoneNumber",
          label: I18n.t("Shop phone"),
          placeholder: I18n.t("01 23 45 67 89")
        }), JsxRuntime.jsx(ShopEditForm.InputText.make, {
          field: "Website",
          label: I18n.t("Shop website"),
          placeholder: "www.boutique.com"
        })]
      }), JsxRuntime.jsxs(Stack.make, {
        children: [importFailureMessage !== undefined ? JsxRuntime.jsx(NextBanner.make, {
          children: JsxRuntime.jsx(NextBanner.Text.make, {
            text: importFailureMessage
          }),
          variation: "danger"
        }) : null, JsxRuntime.jsx(DropZone.make, {
          children: JsxRuntime.jsx(CanarySurface.make, {
            tone: "neutral",
            borderStyle: "dashed",
            grow: true,
            children: JsxRuntime.jsx(Box.make, {
              children: JsxRuntime.jsxs(Stack.make, {
                children: [tmp, JsxRuntime.jsxs(Stack.make, {
                  children: [JsxRuntime.jsx(Title.make, {
                    children: I18n.t("Drag and drop your image"),
                    level: 3,
                    align: "center",
                    weight: "bold"
                  }), JsxRuntime.jsxs(Inline.make, {
                    children: [JsxRuntime.jsx(TextStyle.make, {
                      children: requirementsText,
                      align: "center",
                      variation: "normal",
                      size: "small"
                    }), JsxRuntime.jsx(TooltipIcon.make, {
                      children: JsxRuntime.jsx(Tooltip.Span.make, {
                        text: I18n.t("Square format recommended · Minimum width: 800 px")
                      }),
                      variation: "info"
                    })],
                    space: "xsmall",
                    alignY: "center"
                  })],
                  space: "xsmall",
                  align: "center"
                }), JsxRuntime.jsx(FilePicker.make, {
                  children: JsxRuntime.jsx(Button.make, {
                    label: I18n.t("Select an image")
                  }),
                  types: ["png", "jpeg"],
                  maxSizeMb: 0.2,
                  onChange: onFileSelect,
                  onError: onFileError
                })],
                space: "large",
                align: "center"
              }),
              spaceX: "large",
              spaceY: "xlarge"
            })
          }),
          customSubtitle: requirementsText,
          types: ["png", "jpeg"],
          maxSizeMb: 0.2,
          onSuccess: onFileSelect,
          onError: onFileError
        })],
        space: "medium"
      })],
      grid: ["55%", "45%"],
      spaceX: "xlarge"
    })
  });
}
let make$5 = React.memo(SettingsShopsPage$ShopEditFormGeneralInformationFieldset);
let ShopEditFormGeneralInformationFieldset = {
  styles: styles,
  make: make$5
};
function SettingsShopsPage$ShopEditFormShopFieldset(props) {
  return JsxRuntime.jsx(FieldsetLayoutPanel.make, {
    title: I18n.t("Selected shop"),
    description: I18n.t("Select the store for which you want to view or modify information."),
    accent: true,
    space: "xlarge",
    padding: "xxlarge",
    children: JsxRuntime.jsx(Auth.InputSelectSingleShopField.make, {
      value: props.activeShop,
      required: false
    })
  });
}
let ShopEditFormShopFieldset = {
  make: SettingsShopsPage$ShopEditFormShopFieldset
};
function shopInputValues(selectedShop) {
  return {
    name: selectedShop.name,
    email: selectedShop.email,
    address: selectedShop.address,
    postalCode: selectedShop.postalCode,
    city: selectedShop.city,
    cityOfRegistryOffice: Stdlib_Option.getOr(selectedShop.cityOfRegistryOffice, ""),
    country: countryFromShop(selectedShop),
    phoneNumber: selectedShop.phoneNumber,
    website: Stdlib_Option.getOr(selectedShop.website, ""),
    fiscalYearEndClosingMonth: Stdlib_Option.flatMap(selectedShop.fiscalYearEndClosingMonth, FiscalYearOpeningMonth.fromLowercaseString),
    taxationRegime: ElectronicInvoicing.TaxationRegime.fromShop(selectedShop),
    corporateName: selectedShop.corporateName,
    legalRepresentative: Stdlib_Option.getOr(selectedShop.legalRepresentative, ""),
    legalForm: Stdlib_Option.getOr(selectedShop.legalForm, ""),
    amountOfShareCapital: Stdlib_Option.flatMap(selectedShop.amountOfShareCapital, CorporateEntity.ShareCapital.fromString),
    employeesNumber: ElectronicInvoicing.EmployeesNumber.fromShop(selectedShop),
    tvaNumber: Stdlib_Option.getOr(selectedShop.tvaNumber, ""),
    siretNumber: Stdlib_Option.getOr(selectedShop.siretNumber, ""),
    rcsNumber: Stdlib_Option.getOr(selectedShop.rcsNumber, ""),
    apeNafCode: Stdlib_Option.getOr(selectedShop.apeNafCode, ""),
    bankName: Stdlib_Option.getOr(selectedShop.bankName, ""),
    bankCode: Stdlib_Option.getOr(selectedShop.bankCode, ""),
    bankAccountHolder: Stdlib_Option.getOr(selectedShop.bankAccountHolder, ""),
    bankAccountNumber: Stdlib_Option.getOr(selectedShop.bankAccountNumber, ""),
    bicCode: Stdlib_Option.getOr(selectedShop.bicCode, ""),
    ibanNumber: Stdlib_Option.getOr(selectedShop.ibanNumber, "")
  };
}
let schema = [{
  TAG: "StringNotEmpty",
  _0: "Name"
}, {
  TAG: "StringNotEmpty",
  _0: "Address"
}, {
  TAG: "StringNotEmpty",
  _0: "PostalCode"
}, {
  TAG: "StringNotEmpty",
  _0: "City"
}, {
  TAG: "OptionDefined",
  _0: "Country"
}, {
  TAG: "StringNotEmpty",
  _0: "LegalForm"
}, {
  TAG: "OptionDefined",
  _0: "EmployeesNumber"
}, {
  TAG: "OptionDefined",
  _0: "TaxationRegime"
}, {
  TAG: "OptionDefined",
  _0: "FiscalYearEndClosingMonth"
}, {
  TAG: "StringNotEmpty",
  _0: "BankName"
}, {
  TAG: "StringNotEmpty",
  _0: "BankAccountHolder"
}, {
  TAG: "StringNotEmpty",
  _0: "IbanNumber"
}, {
  TAG: "StringNotEmpty",
  _0: "BicCode"
}, {
  TAG: "CustomString",
  _0: "CorporateName",
  _1: (value, param) => {
    if (CorporateEntity.CorporateName.validate(value)) {
      return {
        TAG: "Ok",
        _0: undefined
      };
    } else {
      return {
        TAG: "Error",
        _0: I18n.t("The corporate name is invalid. Please provide the full name of the company.")
      };
    }
  }
}, {
  TAG: "CustomString",
  _0: "LegalRepresentative",
  _1: (value, param) => {
    if (value.length < 3) {
      return {
        TAG: "Error",
        _0: I18n.t("The legal representative is not valid, full name must be given.")
      };
    } else {
      return {
        TAG: "Ok",
        _0: undefined
      };
    }
  }
}, {
  TAG: "PhoneNumber",
  _0: "PhoneNumber"
}, {
  TAG: "Email",
  _0: "Email"
}, {
  TAG: "CustomString",
  _0: "SiretNumber",
  _1: (value, values) => {
    let match = values.country;
    if (match !== undefined) {
      switch (match) {
        case "BE":
          if (value !== "" && !CompanyLegalNumber.Belgian.isValidBce(value)) {
            return {
              TAG: "Error",
              _0: I18n.t("The BCE number must contain 10 digits.")
            };
          } else {
            return {
              TAG: "Ok",
              _0: undefined
            };
          }
        case "LU":
          return {
            TAG: "Ok",
            _0: undefined
          };
      }
    }
    if (CompanyLegalNumber.French.isValidSiret(value)) {
      return {
        TAG: "Ok",
        _0: undefined
      };
    } else {
      return {
        TAG: "Error",
        _0: I18n.t("siret_input_field.error_message")
      };
    }
  }
}, {
  TAG: "CustomString",
  _0: "TvaNumber",
  _1: (value, values) => {
    let match = values.country;
    if (value === "") {
      return {
        TAG: "Ok",
        _0: undefined
      };
    }
    if (match === "BE") {
      if (CompanyLegalNumber.Belgian.isValidVatNumber(value)) {
        return {
          TAG: "Ok",
          _0: undefined
        };
      } else {
        return {
          TAG: "Error",
          _0: I18n.t("The VAT number is not valid.")
        };
      }
    }
    if (CompanyLegalNumber.Vat.isValid(value)) {
      return {
        TAG: "Ok",
        _0: undefined
      };
    } else {
      return {
        TAG: "Error",
        _0: I18n.t("The VAT number is not valid.")
      };
    }
  }
}];
function requiredDataMissing(shop) {
  let values = shopInputValues(shop);
  return schema.some(rule => {
    switch (rule.TAG) {
      case "OptionDefined":
        return Stdlib_Option.isNone(get(values, rule._0));
      case "StringNotEmpty":
      case "PhoneNumber":
      case "Email":
        break;
      case "CustomString":
        if (get(values, rule._0) === "") {
          return Stdlib_Result.isError(rule._1("", values));
        } else {
          return false;
        }
      default:
        return false;
    }
    return get(values, rule._0) === "";
  });
}
function SettingsShopsPage(props) {
  let updateShopRequest = props.updateShopRequest;
  let match = React.useState(() => {});
  let setNotification = match[1];
  let notification = match[0];
  let match$1 = React.useState(() => {});
  let setLogoFile = match$1[1];
  let logoFile = match$1[0];
  let containerRef = React.useRef(null);
  let scrollToTop = () => Stdlib_Option.forEach(ReactDomElement.fromRef(containerRef), ScrollHelpers.scrollAncestorsToTop);
  React.useEffect(() => {
    if (Stdlib_Option.isSome(notification)) {
      Stdlib_Option.forEach(ReactDomElement.fromRef(containerRef), ScrollHelpers.scrollAncestorsToTop);
    }
  }, [notification]);
  let activeShop = Auth.useActiveShopExn();
  let scope = Auth.useScope();
  let match$2 = Navigation.useGoBack();
  let onGoBack = match$2[1];
  let logUser = Auth.useLogUser(undefined, undefined);
  let jwt = Stdlib_Option.getOr(Auth.getJwt(), "");
  let onSubmitSuccess = param => {
    logUser(jwt);
    setLogoFile(param => {});
    setNotification(param => ({
      TAG: "Ok",
      _0: I18n.t("Your shop changes have been saved successfully.")
    }));
  };
  let onSubmitFailure = message => setNotification(param => ({
    TAG: "Error",
    _0: message
  }));
  let match$3 = ShopEditForm.useFormPropState({
    id: activeShop.id,
    initialValues: shopInputValues(activeShop),
    schema: schema,
    onSubmitFailure: onSubmitFailure,
    onSubmitSuccess: onSubmitSuccess
  });
  let formDispatch = match$3[1];
  let formState = match$3[0];
  let url = Navigation.useUrl();
  let requiredDataValidationRequested = url.query.split("&").includes(SettingsRoutes.shopsRequiredDataQuery);
  React.useEffect(() => {
    if (requiredDataValidationRequested && requiredDataMissing(activeShop)) {
      formDispatch("ValidationRequested");
      formDispatch({
        TAG: "SubmissionFailed",
        _0: I18n.t("settings_shops_page.required_data_validation.message")
      });
    } else {
      setNotification(param => {});
    }
  }, [activeShop.id]);
  let match$4 = React.useState(() => false);
  let setSiretNumberNotFound = match$4[1];
  let match$5 = React.useState(() => {});
  let setLegalForm = match$5[1];
  React.useEffect(() => {
    setSiretNumberNotFound(param => false);
    setLegalForm(param => {});
  }, [formState.values.siretNumber]);
  let onCompanyFound = lookup => {
    if (lookup !== undefined) {
      let company = lookup.company;
      let legalForm = lookup.legalForm;
      setSiretNumberNotFound(param => false);
      setLegalForm(param => legalForm);
      formDispatch({
        TAG: "FieldValueChanged",
        _0: "CorporateName",
        _1: param => company.corporateName
      });
      formDispatch({
        TAG: "FieldValueChanged",
        _0: "TvaNumber",
        _1: param => company.vatNumber
      });
      return formDispatch({
        TAG: "FieldValueChanged",
        _0: "ApeNafCode",
        _1: param => company.apeNafCode
      });
    }
    setSiretNumberNotFound(param => true);
    setLegalForm(param => {});
  };
  let submitDisabled = isFrenchCountry(formState.values.country) && match$4[0];
  let handleFormSubmit = (param, param$1) => {
    let ibanNumber = param$1.ibanNumber;
    let bicCode = param$1.bicCode;
    let bankAccountNumber = param$1.bankAccountNumber;
    let bankAccountHolder = param$1.bankAccountHolder;
    let bankCode = param$1.bankCode;
    let bankName = param$1.bankName;
    let apeNafCode = param$1.apeNafCode;
    let rcsNumber = param$1.rcsNumber;
    let siretNumber = param$1.siretNumber;
    let tvaNumber = param$1.tvaNumber;
    let employeesNumber = param$1.employeesNumber;
    let amountOfShareCapital = param$1.amountOfShareCapital;
    let legalForm = param$1.legalForm;
    let legalRepresentative = param$1.legalRepresentative;
    let corporateName = param$1.corporateName;
    let taxationRegime = param$1.taxationRegime;
    let fiscalYearEndClosingMonth = param$1.fiscalYearEndClosingMonth;
    let website = param$1.website;
    let phoneNumber = param$1.phoneNumber;
    let country = param$1.country;
    let cityOfRegistryOffice = param$1.cityOfRegistryOffice;
    let city = param$1.city;
    let postalCode = param$1.postalCode;
    let address = param$1.address;
    let email = param$1.email;
    let name = param$1.name;
    let logoUploadFuture = logoFile !== undefined ? make$1(activeShop.id, Primitive_option.valFromOption(logoFile)) : Future.value({
      TAG: "Ok",
      _0: Json.encodeDict({})
    });
    return Future.flatMap(logoUploadFuture, undefined, logoResult => {
      if (logoResult.TAG === "Ok") {
        if (country !== undefined) {
          return Future.mapError(Future.mapOk(updateShopRequest(activeShop.id, name, address, postalCode, city, cityOfRegistryOffice, CountryCode.toMediumCountryString(country), phoneNumber, email, website, Stdlib_Option.mapOr(fiscalYearEndClosingMonth, "", FiscalYearOpeningMonth.toLowercaseString), taxationRegime, employeesNumber, corporateName, legalRepresentative, legalForm, Stdlib_Option.mapOr(amountOfShareCapital, "", CorporateEntity.ShareCapital.toString), CompanyLegalNumber.Vat.normalize(tvaNumber), siretNumber, rcsNumber, apeNafCode, bankName, bankCode, bankAccountHolder, bankAccountNumber, bicCode, ibanNumber), undefined, param => I18n.t("Your shop information has been updated successfully.")), undefined, error => {
            if (error === undefined) {
              return I18n.t("An unexpected error occured. Please try again or contact the support.");
            }
            switch (error) {
              case "ShopArchivedFailure":
                return I18n.t("This shop has been archived.");
              case "NotFoundShopFailure":
                return I18n.t("This shop does not exist.");
              default:
                return I18n.t("An unexpected error occured. Please try again or contact the support.");
            }
          });
        } else {
          return Future.value({
            TAG: "Error",
            _0: I18n.t("An unexpected error occured. Please try again or contact the support.")
          });
        }
      } else {
        return Future.value({
          TAG: "Error",
          _0: I18n.t("Failed to upload logo. Please try again or contact the support.")
        });
      }
    });
  };
  let edited = Primitive_object.notequal(formState.values, formState.initialValues) || Stdlib_Option.isSome(logoFile);
  let mainActionsElement = edited ? JsxRuntime.jsxs(Inline.make, {
    children: [JsxRuntime.jsx(ShopEditForm.CancelButton.make, {
      label: I18n.t("Cancel"),
      onPress: onGoBack
    }), JsxRuntime.jsx(ShopEditForm.SubmitButton.make, {
      label: I18n.t("Save"),
      tone: "success",
      disabled: submitDisabled,
      onSubmitRequested: scrollToTop,
      onSubmit: handleFormSubmit
    })],
    space: "small"
  }) : JsxRuntime.jsx(Button.make, {
    label: I18n.t("Back"),
    onPress: () => onGoBack()
  });
  let notificationBanner = notification !== undefined ? JsxRuntime.jsx(NextBanner.make, {
    children: JsxRuntime.jsx(NextBanner.Text.make, {
      text: notification._0
    }),
    variation: Stdlib_Result.isOk(notification) ? "success" : "danger"
  }) : null;
  let generalInformationFieldset = JsxRuntime.jsx(make$5, {
    shop: activeShop,
    onLogoChange: file => setLogoFile(param => file)
  });
  let tmp;
  tmp = scope.TAG === "Organisation" ? JsxRuntime.jsxs(Stack.make, {
    children: [JsxRuntime.jsx(SettingsShopsPage$ShopEditFormShopFieldset, {
      activeShop: activeShop
    }), JsxRuntime.jsx(CanarySeparator.make, {
      orientation: "horizontal"
    }), generalInformationFieldset],
    space: "xlarge"
  }) : generalInformationFieldset;
  let tmp$1;
  tmp$1 = scope.TAG === "Organisation" ? I18n.t("Shops") : I18n.t("Shop");
  let name = formState.values.name.trim();
  let tmp$2 = name === "" ? I18n.t("Shop name") : name;
  return JsxRuntime.jsx(ShopEditForm.Core.Provider.make, {
    children: JsxRuntime.jsx(NextPage.make, {
      children: JsxRuntime.jsx("div", {
        children: JsxRuntime.jsxs(Stack.make, {
          children: [notificationBanner, tmp, JsxRuntime.jsx(make$3, {
            legalForm: match$5[0],
            invoicingEndpoint: ElectronicInvoicing.InvoicingEndpoint.make(activeShop.invoicingEndpointIdSchemeType, activeShop.invoicingEndpointIdSchemeCode, activeShop.invoicingEndpointId),
            onCompanyFound: onCompanyFound
          }), JsxRuntime.jsx(make$4, {
            countryDisabled: Stdlib_Option.isSome(countryFromShop(activeShop))
          }), JsxRuntime.jsx(make$2, {})],
          space: "xxlarge"
        }),
        ref: Primitive_option.some(containerRef)
      }),
      title: tmp$1,
      subtitle: tmp$2,
      subtitleBadgeElement: edited ? JsxRuntime.jsx(NextBadge.make, {
        kind: "Neutral",
        label: I18n.t("Draft"),
        size: "L",
        icon: "Pending"
      }) : undefined,
      mainActionsElement: mainActionsElement
    }),
    propState: [formState, formDispatch]
  });
}
let make$6 = SettingsShopsPage;
export { UpdateShopRequest, UploadShopLogoRequest, ShopEditFormLenses, ShopEditForm, countryFromShop, isFrenchCountry, ShopEditFormBankingInformationFieldset, ShopEditFormLegalInformationFieldset, ShopEditFormAddressFieldset, ShopEditFormGeneralInformationFieldset, ShopEditFormShopFieldset, shopInputValues, schema, requiredDataMissing, make$6 as make };
/* endpoint Not a pure module */